export default __webpack_public_path__ + "static/media/CustomStatsIcon.bbb5c7fd.png";